import axios from 'axios';
import { URL } from "../config";
const BASE_URL = URL;

const OpenCallService = {
  listActive: async (semesterId, options = {}) => {
    try {
      const response = await axios.get(`${BASE_URL}/opencall/list`, {
        params: {
          semester: semesterId,
          scope: "active",
          includeEvent: true,
          ...(options.department ? { department: options.department } : {}),
        },
        headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
      });
      return response.data || [];
    } catch (error) {
      throw new Error(`Error listing active open calls: ${error.message}`);
    }
  },

  listClosed: async (semesterId, page = 1, options = {}) => {
    try {
      const response = await axios.get(`${BASE_URL}/opencall/list`, {
        params: {
          semester: semesterId,
          status: "Closed",
          page,
          limit: options.limit || 10,
          includeEvent: true,
          ...(options.department ? { department: options.department } : {}),
        },
        headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
      });
      return response.data;
    } catch (error) {
      throw new Error(`Error listing closed open calls: ${error.message}`);
    }
  },

  createOC: async (openCallData) => {
    try {
      const response = await axios.post(`${BASE_URL}/opencall/`, openCallData);
      return response.data;
    } catch (error) {
      throw new Error(`Error creating open call: ${error.message}`);
    }
  },

  createOCAdmin: async (openCallData) => {
    try {
      const response = await axios.post(`${BASE_URL}/opencall/admin/create`, openCallData);
      return response.data;
    } catch (error) {
      throw new Error(`Error creating open call: ${error.message}`);
    }
  },

  editOC: async (openCallId, updateData) => {
    try {
      const response = await axios.put(`${BASE_URL}/opencall/edit/${openCallId}`, updateData);
      return response.data;
    } catch (error) {
      throw new Error(`Error updating open call: ${error.message}`);
    }
  },

  deleteOC: async (openCallId) => {
    try {
      const response = await axios.delete(`${BASE_URL}/opencall/${openCallId}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error deleting open call: ${error.message}`);
    }
  },

  getOCByEventId: async (eventId) => {
    try {
      const response = await axios.get(`${BASE_URL}/opencall/from_event/${eventId}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error getting open call by event: ${error.message}`);
    }
  },

  sendShot: async (openCallId, comment) => {
    try {
      const response = await axios.put(`${BASE_URL}/opencall/send_shot/`, { openCallId, comment });
      return response.data;
    } catch (error) {
      throw new Error(`Error sending shot: ${error.message}`);
    }
  },

  sendShotAsAdmin: async (openCallId, userId, comment) => {
    try {
      const response = await axios.put(`${BASE_URL}/opencall/admin/send_shot/`, {
        openCallId,
        userId,
        comment,
      });
      return response.data;
    } catch (error) {
      throw new Error(`Error sending shot: ${error.message}`);
    }
  },

  cancelShot: async (openCallId) => {
    try {
      const response = await axios.put(`${BASE_URL}/opencall/cancel_shot/`, { openCallId });
      return response.data;
    } catch (error) {
      throw new Error(`Error canceling shot: ${error.message}`);
    }
  },

  cancelShotAsAdmin: async (openCallId, userId) => {
    try {
      const response = await axios.put(`${BASE_URL}/opencall/admin/cancel_shot/`, {
        openCallId,
        userId,
      });
      return response.data;
    } catch (error) {
      throw new Error(`Error canceling shot: ${error.message}`);
    }
  },

  voteOC: async (openCallId, voterId, votesIds) => {
    try {
      const response = await axios.put(`${BASE_URL}/opencall/vote/`, { openCallId, voterId, votesIds });
      return response.data;
    } catch (error) {
      throw new Error(`Error voting: ${error.message}`);
    }
  },

  openOC: async (openCallPayload) => {
    try {
      const response = await axios.put(`${BASE_URL}/opencall/open/`, { updateData: openCallPayload });
      return response.data;
    } catch (error) {
      throw new Error(`Error opening open call: ${error.message}`);
    }
  },

  closeOC: async (openCallId) => {
    try {
      const response = await axios.put(`${BASE_URL}/opencall/close/`, { openCallId });
      return response.data;
    } catch (error) {
      throw new Error(`Error closing open call: ${error.message}`);
    }
  },

  cancelOC: async (openCallId) => {
    try {
      const response = await axios.put(`${BASE_URL}/opencall/cancel/`, { openCallId });
      return response.data;
    } catch (error) {
      throw new Error(`Error canceling open call: ${error.message}`);
    }
  },

  saveWinners: async (openCallId, winners, notify = true, close = false) => {
    try {
      const response = await axios.put(`${BASE_URL}/opencall/${openCallId}/save-winners`, {
        openCallId,
        winners,
        notify,
        close,
      });
      return response.data;
    } catch (error) {
      throw new Error(`Error saving winners for open call: ${error.message}`);
    }
  },
};

export default OpenCallService;
